import { render, staticRenderFns } from "./UpgradeToKYC.vue?vue&type=template&id=4a8d977b&scoped=true&"
import script from "./UpgradeToKYC.vue?vue&type=script&lang=js&"
export * from "./UpgradeToKYC.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToKYC.vue?vue&type=style&index=0&id=4a8d977b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d977b",
  null
  
)

export default component.exports